export const timezones = [
  { value: 'Etc/GMT', text: 'Coordinated Universal Time, UTC±0' },
  { value: 'Europe/Rome', text: 'Italia, UTC+1 / UTC+2 (DST)' },
  { value: 'Europe/London', text: 'Regno Unito, UTC+0 / UTC+1 (DST)' },
  { value: 'Europe/Paris', text: 'Francia, UTC+1 / UTC+2 (DST)' },
  { value: 'Europe/Berlin', text: 'Germania, UTC+1 / UTC+2 (DST)' },
  { value: 'Europe/Moscow', text: 'Russia, UTC+3' },
  { value: 'America/New_York', text: 'USA EST/EDT, UTC−5 / UTC−4' },
  { value: 'America/Chicago', text: 'USA CST/CDT, UTC−6 / UTC−5' },
  { value: 'America/Denver', text: 'USA MST/MDT, UTC−7 / UTC−6' },
  { value: 'America/Los_Angeles', text: 'USA PST/PDT, UTC−8 / UTC−7' },
  { value: 'America/Sao_Paulo', text: 'Brasile, UTC−3' },
  { value: 'America/Argentina/Buenos_Aires', text: 'Argentina, UTC−3' },
  { value: 'America/Noronha', text: 'Brasile (Fernando de Noronha), UTC−2' },
  { value: 'America/Phoenix', text: 'USA MST, UTC−7 (no DST)' },
  { value: 'America/Anchorage', text: 'Alaska, UTC−9 / UTC−8 (DST)' },
  { value: 'Pacific/Honolulu', text: 'Hawaii, UTC−10' },
  { value: 'Asia/Tokyo', text: 'Giappone, UTC+9' },
  { value: 'Asia/Shanghai', text: 'Cina, UTC+8' },
  { value: 'Asia/Kolkata', text: 'India, UTC+5:30' },
  { value: 'Asia/Dubai', text: 'Emirati Arabi Uniti, UTC+4' },
  { value: 'Asia/Bangkok', text: 'Thailandia, UTC+7' },
  { value: 'Asia/Dhaka', text: 'Bangladesh, UTC+6' },
  { value: 'Australia/Sydney', text: 'Australia EST/AEDT, UTC+10 / UTC+11' },
  { value: 'Australia/Perth', text: 'Australia WST, UTC+8' },
  { value: 'Pacific/Auckland', text: 'Nuova Zelanda, UTC+12 / UTC+13' },
  { value: 'Pacific/Tongatapu', text: 'Tonga, UTC+13' },
  { value: 'Pacific/Kiritimati', text: 'Kiribati, UTC+14' }
];
